// Ortak (taşeron + ana firma portalı) — T.C. kimlik no istemci-taraflı biçim doğrulaması (plan S25 C9,
// `docs/plans/S25-analysis-inbox.md`). `backend/src/Isgportal.Identity/Domain/TcKimlikValidator.cs`
// ile BİREBİR aynı algoritma — yalnız UX ön-uyarısı içindir, sunucu her koşulda kendi kuralını
// yeniden uygular (`POST /supplier/contractor/personnel` → `400 TC_KIMLIK_INVALID`). Devletin
// MERNİS servisine karşı bir gerçeklik kontrolü YAPMAZ, yalnız biçim.
//
// Kural: tam 11 hane, ilk hane `0` olamaz, standart sağlama toplamı:
//   10. hane = ((1,3,5,7,9. hane toplamı × 7) − (2,4,6,8. hane toplamı)) mod 10
//   11. hane = ilk 10 hanenin toplamının mod 10'u
//
// Boş dize burada `false` döner (backend'in `IsValid(null/boş) === true` davranışının TERSİ) —
// orada "alan opsiyonel" kuralı çağıranın işiydi, burada da AYNI: opsiyonellik zod şemasında
// (`v.length === 0 || isValidTcKimlikNo(v)`) ayrı ele alınır, bu fonksiyon yalnız DOLU bir
// değerin biçimini yargılar.

/** Hesaplanmış maske — son iki hane açık, gerisi nokta (D17/F6). Bu fonksiyonun döndürdüğü
 * DIŞINDA bir T.C. karakteri, maskeli haldeyken DOM'a/erişilebilirlik ağacına/tümünü-seç
 * kopyasına ASLA girmemelidir — `-webkit-text-security`/`filter: blur()`/`sr-only` gibi tam
 * değeri render edip CSS/ARIA ile gizleyen yöntemler bu yüzden KULLANILMAZ. `TcKimlikValue`
 * (`personnel/TcKimlikValue.tsx`) bu fonksiyonun TEK tüketicisidir — her iki portalın özet kartı
 * VE düzenleme formu AYNI bileşeni paylaşır, ikinci bir maskeleme uygulaması YAZILMAZ. */
export function maskTcKimlikNo(tc: string): string {
  const last2 = tc.slice(-2);
  return '•'.repeat(Math.max(tc.length - 2, 0)) + last2;
}

/**
 * Sunucunun maskelediği (ya da düz 11 hane OLMAYAN) bir T.C. — fail closed (#29):
 * `personalDataMasked` bayrağı eksik/yanlış gelse bile `•••••••••12` gibi bir değer düz değer
 * sanılmaz. Böyle bir değer yalnız gösterilir — Göster/Gizle sunulmaz, `TcKimlikValue`'ya verilmez,
 * PUT'a girmez. Boş/`null` → `false` (gizlenecek değer yok). `toEditTarget`/`tcLock`/
 * `PersonnelFacts` bu TEK yüklemi kullanır.
 */
export function isServerMaskedTc(value: string | null | undefined): boolean {
  if (value == null || value.trim() === '') {
    return false;
  }
  return !/^\d{11}$/.test(value);
}

export function isValidTcKimlikNo(value: string): boolean {
  if (!/^[1-9]\d{10}$/.test(value)) {
    return false;
  }
  const digits = value.split('').map(Number);
  const at = (index: number): number => digits[index] ?? 0;

  const oddSum = at(0) + at(2) + at(4) + at(6) + at(8);
  const evenSum = at(1) + at(3) + at(5) + at(7);
  let tenthDigit = (oddSum * 7 - evenSum) % 10;
  if (tenthDigit < 0) {
    tenthDigit += 10;
  }
  if (tenthDigit !== at(9)) {
    return false;
  }

  const firstTenSum = digits.slice(0, 10).reduce((sum, d) => sum + d, 0);
  return firstTenSum % 10 === at(10);
}
